import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { LOGOS } from '../../assets/logos';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiBriefcase, FiUsers, FiBarChart3, FiSettings } = FiIcons;

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', icon: FiHome, label: 'Inicio', exact: true },
    { path: '/dashboard/projects', icon: FiBriefcase, label: 'Proyectos' },
    { path: '/dashboard/prospects', icon: FiUsers, label: 'Prospectos' },
    { path: '/dashboard/analytics', icon: FiBarChart3, label: 'Análisis' },
    { path: '/dashboard/settings', icon: FiSettings, label: 'Configuración' },
  ];

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-full">
      <div className="p-6">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center space-x-3 mb-8"
        >
          <img 
            src={LOGOS.BLUE_TRANSPARENT} 
            alt="VIXEA" 
            className="h-10 object-contain" 
          />
          <div>
            <p className="text-xs text-gray-500">Entrevistas Inteligentes</p>
          </div>
        </motion.div>

        <nav className="space-y-2">
          {menuItems.map((item, index) => (
            <motion.div
              key={item.path}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <NavLink
                to={item.path}
                end={item.exact}
                className={({ isActive }) =>
                  `flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? 'bg-primary text-white shadow-lg'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`
                }
              >
                <SafeIcon icon={item.icon} className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </NavLink>
            </motion.div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;